











import Vue from 'vue';
// @ts-ignore
import { Portal } from '@linusborg/vue-simple-portal';

export default Vue.extend({
    name: 'DvPopover',
    components: { Portal },
    props: {
        open: { type: Boolean, default: false },
        anchor: { type: Object as () => HTMLElement | null, default: null },
    },
    data() {
        return { style: {} as Record<string, string> };
    },
    watch: {
        open(now: boolean) {
            if (now) {
                this.position();
                //  vue-simple-portal mounts its target content behind its own
                //  nextTick (from Portal's `created` hook), one tick behind this
                //  watcher. A single nextTick here still races that mount, so the
                //  ref is empty and focus() silently no-ops; wait one more tick.
                this.$nextTick(() => {
                    this.$nextTick(() => (this.$refs.panel as HTMLElement | undefined)?.focus());
                });
            } else {
                this.anchor?.focus();
            }
        },
        //  Route changes must not strand an open panel in the portal.
        $route() { if (this.open) this.$emit('close'); },
    },
    methods: {
        position() {
            if (!this.anchor) return;
            const r = this.anchor.getBoundingClientRect();
            this.style = {
                position: 'fixed',
                top: `${Math.round(r.bottom + 4)}px`,
                left: `${Math.round(r.left)}px`,
                minWidth: `${Math.round(r.width)}px`,
            };
        },
    },
});
